<template>
  <div class="w-full min-h-screen max-w-full">
    <AppShell />
    <Toast />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AppShell from '@/components/lvm/layouts/AppShell.vue'
import Toast from './components/lvm/molecules/Toast.vue'
import { get } from '@/crud'

export default {
  data: () => ({
    dialog: true,
  }),
  components: {
    AppShell,
    Toast,
  },

  computed: {
    ...mapState(['user', 'toastMessage', 'errorMessage']),
  },

  methods: {
    isPublicRoute() {
      return this.$route.matched.some((routeRecord) => routeRecord.meta?.public)
    },
    async getUser() {
      const user = localStorage.getItem('user')
      if (!user || user === 'undefined' || user === 'null') {
        if (!this.isPublicRoute()) {
          return this.logout()
        }
        return
      }
      const parsedUser = JSON.parse(user)
      if (!parsedUser?.id) {
        if (!this.isPublicRoute()) {
          return this.logout()
        }
        return
      }
      this.$store.dispatch('setUser', parsedUser)

      const me = await get('me')
      if (me?.id) {
        localStorage.setItem('user', JSON.stringify(me))
        this.$store.dispatch('setUser', me)
        return
      }

      this.logout()
    },
    logout() {
      localStorage.removeItem('user')
      this.$store.dispatch('setUser', null)
      if (!this.isPublicRoute()) {
        this.$router.push('/login')
      }
    },
  },

  async mounted() {
    // Sem esperar o router resolver a navegacao inicial, this.$route.matched
    // ainda esta vazio aqui e isPublicRoute() responde false por engano,
    // derrubando para /login qualquer rota publica aberta direto pela URL.
    await this.$router.isReady()
    await this.getUser()
  },

  watch: {
    user() {
      if (!this.user && !this.isPublicRoute()) {
        this.$router.push('/login')
      }
    },
  },
}
</script>
